"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// 默认request prefix
var _default = function _default(url, options) {
  var _window, _window$G_GOV_BIZ_CON;

  var requestPrefix = ((_window = window) === null || _window === void 0 ? void 0 : (_window$G_GOV_BIZ_CON = _window.G_GOV_BIZ_CONFIG) === null || _window$G_GOV_BIZ_CON === void 0 ? void 0 : _window$G_GOV_BIZ_CON.requestPrefix) || '';
  return {
    url: "".concat(requestPrefix).concat(url),
    options: options
  };
};

exports.default = _default;